export const lightTheme = {
  mode: 'light',
  bg: '#ffd3e8ff',
  text: '#2e4033ff',
  lightShadow: '#f8e2ebff',
  darkShadow: '#c394a9ff',
  // accent: '#e0a100',
  // accentDark: '#b98500',
  accent: '#ed4779ff',
  accent2: '#f4a9cdff',
  accentDark: '#627d6bff',
  accentDark2: '#4f3366ff',

  cursive: '"Lily Script One", system-ui',
  sansSerif: '"Space Grotesk", sans-serif',
  code: '"Anonymous Pro", monospace',
  bold: '"Space Grotesk", sans-serif'
}
  
  export const darkTheme = {
    mode: 'dark',
    bg: '#232323ff',
    text: '#FAFAFA',
    lightShadow: '#525252',
    darkShadow: '#000000',
    accent: '#ffc4d7',
    accent2: '#454242ff',
    accentDark: '#caeed6ff',
    accentDark2: '#d5bee9ff',
    cursive: '"Lily Script One", system-ui',
    sansSerif: '"Space Grotesk", sans-serif',
    code: '"Anonymous Pro", monospace',
    bold: '"Space Grotesk", sans-serif'
  }